import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["component", "render"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
/* eslint-disable-next-line no-restricted-imports */
import { Route } from 'react-router-dom';
import RouterContext from './RouterContext';

/* eslint-disable-next-line no-restricted-imports */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wraps react-router's Route children with context to support hooks (useLocation, useParams etc).
 * Check ./hooks/index.js for the hooks implemetation.
 */
export const RouteWithContext = props => {
  const {
      component: Component,
      render: _render
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(Route, _objectSpread(_objectSpread({}, rest), {}, {
    render: routeProps => {
      return /*#__PURE__*/_jsx(RouterContext.Provider, {
        value: {
          location: routeProps.location,
          history: routeProps.history,
          match: routeProps.match
        },
        children: _render ? _render(routeProps) : Component ? /*#__PURE__*/_jsx(Component, _objectSpread({}, routeProps)) : null
      });
    }
  }));
};